import { render, staticRenderFns } from "./dailyCapacities.vue?vue&type=template&id=2634d992&"
import script from "./dailyCapacities.vue?vue&type=script&lang=js&"
export * from "./dailyCapacities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports